// Copyright (c) 2018 Swashata Ghosh <swashata@wpquark.com>
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

import '../scss/blue-grey-theme.scss';
import '../scss/blue-theme.scss';
import '../scss/brown-theme.scss';
import '../scss/cyan-theme.scss';
import '../scss/deep-orange-theme.scss';
import '../scss/deep-purple-theme.scss';
import '../scss/default-theme.scss';
import '../scss/green-theme.scss';
import '../scss/indigo-theme.scss';
import '../scss/light-blue-theme.scss';
import '../scss/orange-theme.scss';
import '../scss/pink-theme.scss';
import '../scss/purple-theme.scss';
import '../scss/red-theme.scss';
import '../scss/teal-theme.scss';
